import script from "./LlSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./LlSupport.vue?vue&type=script&setup=true&lang=js"

import "./LlSupport.vue?vue&type=style&index=0&id=5e203372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e203372"]])

export default __exports__